import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import CreateVehicle from "./CreateVehicle";

const CreateVehicleHeader = () => {
  useEffect(() => { GridStack.init(); }, []);

  const layoutData = [
    {
      x: 0, y: 0, width: 12, height: 1, id: 0,
      component: (
        <DMSHeader
          title="Vehicle Management"
          showdownload={false}
          fileName="Vehicle Details"
          showIconsForback={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0, y: 1, width: 12, height: 13, id: 1,
      component: <CreateVehicle />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateVehicleHeader;
